import { css } from "@emotion/react";

export const styles = {
  typography__description: css`
    word-break: break-word;

    ul,
    ol {
      padding-inline-start: 40px;
    }
  `
};
